import { render } from "./Tab.vue?vue&type=template&id=b52ad3fe&scoped=true&ts=true"
import script from "./Tab.vue?vue&type=script&lang=ts"
export * from "./Tab.vue?vue&type=script&lang=ts"

import "./Tab.vue?vue&type=style&index=0&id=b52ad3fe&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b52ad3fe"]])

export default __exports__